/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SearchRouteImport } from './routes/search'
import { Route as FilterRouteImport } from './routes/filter'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PlanIndexRouteImport } from './routes/plan.index'
import { Route as TripTripIdRouteImport } from './routes/trip.$tripId'
import { Route as StopStopIdRouteImport } from './routes/stop.$stopId'
import { Route as SettingsPoisRouteImport } from './routes/settings.pois'
import { Route as PlanSelectRouteImport } from './routes/plan.select'
import { Route as PlanNavigateRouteImport } from './routes/plan.navigate'
import { Route as PlanItineraryRouteImport } from './routes/plan.itinerary'
import { Route as MicromobilityStopIdRouteImport } from './routes/micromobility.$stopId'
import { Route as PlanPoiIndexRouteImport } from './routes/plan.poi.index'
import { Route as TripTripIdDateRouteImport } from './routes/trip.$tripId.$date'
import { Route as PlanSelectSelectTypeRouteImport } from './routes/plan.select.$selectType'
import { Route as PlanPoiSelectTypeIndexRouteImport } from './routes/plan.poi.$selectType.index'
import { Route as PlanModeCoordinatesDatetimeTypePageIndexRouteImport } from './routes/plan.$mode.$coordinates.$datetime.$type.$page.index'
import { Route as PlanModeCoordinatesDatetimeTypePageItinIndexRouteImport } from './routes/plan.$mode.$coordinates.$datetime.$type.$page.$itinIndex'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const FilterRoute = FilterRouteImport.update({
  id: '/filter',
  path: '/filter',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PlanIndexRoute = PlanIndexRouteImport.update({
  id: '/plan/',
  path: '/plan/',
  getParentRoute: () => rootRouteImport,
} as any)
const TripTripIdRoute = TripTripIdRouteImport.update({
  id: '/trip/$tripId',
  path: '/trip/$tripId',
  getParentRoute: () => rootRouteImport,
} as any)
const StopStopIdRoute = StopStopIdRouteImport.update({
  id: '/stop/$stopId',
  path: '/stop/$stopId',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPoisRoute = SettingsPoisRouteImport.update({
  id: '/pois',
  path: '/pois',
  getParentRoute: () => SettingsRoute,
} as any)
const PlanSelectRoute = PlanSelectRouteImport.update({
  id: '/plan/select',
  path: '/plan/select',
  getParentRoute: () => rootRouteImport,
} as any)
const PlanNavigateRoute = PlanNavigateRouteImport.update({
  id: '/plan/navigate',
  path: '/plan/navigate',
  getParentRoute: () => rootRouteImport,
} as any)
const PlanItineraryRoute = PlanItineraryRouteImport.update({
  id: '/plan/itinerary',
  path: '/plan/itinerary',
  getParentRoute: () => rootRouteImport,
} as any)
const MicromobilityStopIdRoute = MicromobilityStopIdRouteImport.update({
  id: '/micromobility/$stopId',
  path: '/micromobility/$stopId',
  getParentRoute: () => rootRouteImport,
} as any)
const PlanPoiIndexRoute = PlanPoiIndexRouteImport.update({
  id: '/plan/poi/',
  path: '/plan/poi/',
  getParentRoute: () => rootRouteImport,
} as any)
const TripTripIdDateRoute = TripTripIdDateRouteImport.update({
  id: '/$date',
  path: '/$date',
  getParentRoute: () => TripTripIdRoute,
} as any)
const PlanSelectSelectTypeRoute = PlanSelectSelectTypeRouteImport.update({
  id: '/$selectType',
  path: '/$selectType',
  getParentRoute: () => PlanSelectRoute,
} as any)
const PlanPoiSelectTypeIndexRoute = PlanPoiSelectTypeIndexRouteImport.update({
  id: '/plan/poi/$selectType/',
  path: '/plan/poi/$selectType/',
  getParentRoute: () => rootRouteImport,
} as any)
const PlanModeCoordinatesDatetimeTypePageIndexRoute =
  PlanModeCoordinatesDatetimeTypePageIndexRouteImport.update({
    id: '/plan/$mode/$coordinates/$datetime/$type/$page/',
    path: '/plan/$mode/$coordinates/$datetime/$type/$page/',
    getParentRoute: () => rootRouteImport,
  } as any)
const PlanModeCoordinatesDatetimeTypePageItinIndexRoute =
  PlanModeCoordinatesDatetimeTypePageItinIndexRouteImport.update({
    id: '/plan/$mode/$coordinates/$datetime/$type/$page/$itinIndex',
    path: '/plan/$mode/$coordinates/$datetime/$type/$page/$itinIndex',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/filter': typeof FilterRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRouteWithChildren
  '/micromobility/$stopId': typeof MicromobilityStopIdRoute
  '/plan/itinerary': typeof PlanItineraryRoute
  '/plan/navigate': typeof PlanNavigateRoute
  '/plan/select': typeof PlanSelectRouteWithChildren
  '/settings/pois': typeof SettingsPoisRoute
  '/stop/$stopId': typeof StopStopIdRoute
  '/trip/$tripId': typeof TripTripIdRouteWithChildren
  '/plan/': typeof PlanIndexRoute
  '/plan/select/$selectType': typeof PlanSelectSelectTypeRoute
  '/trip/$tripId/$date': typeof TripTripIdDateRoute
  '/plan/poi/': typeof PlanPoiIndexRoute
  '/plan/poi/$selectType/': typeof PlanPoiSelectTypeIndexRoute
  '/plan/$mode/$coordinates/$datetime/$type/$page/$itinIndex': typeof PlanModeCoordinatesDatetimeTypePageItinIndexRoute
  '/plan/$mode/$coordinates/$datetime/$type/$page/': typeof PlanModeCoordinatesDatetimeTypePageIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/filter': typeof FilterRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRouteWithChildren
  '/micromobility/$stopId': typeof MicromobilityStopIdRoute
  '/plan/itinerary': typeof PlanItineraryRoute
  '/plan/navigate': typeof PlanNavigateRoute
  '/plan/select': typeof PlanSelectRouteWithChildren
  '/settings/pois': typeof SettingsPoisRoute
  '/stop/$stopId': typeof StopStopIdRoute
  '/trip/$tripId': typeof TripTripIdRouteWithChildren
  '/plan': typeof PlanIndexRoute
  '/plan/select/$selectType': typeof PlanSelectSelectTypeRoute
  '/trip/$tripId/$date': typeof TripTripIdDateRoute
  '/plan/poi': typeof PlanPoiIndexRoute
  '/plan/poi/$selectType': typeof PlanPoiSelectTypeIndexRoute
  '/plan/$mode/$coordinates/$datetime/$type/$page/$itinIndex': typeof PlanModeCoordinatesDatetimeTypePageItinIndexRoute
  '/plan/$mode/$coordinates/$datetime/$type/$page': typeof PlanModeCoordinatesDatetimeTypePageIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/filter': typeof FilterRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRouteWithChildren
  '/micromobility/$stopId': typeof MicromobilityStopIdRoute
  '/plan/itinerary': typeof PlanItineraryRoute
  '/plan/navigate': typeof PlanNavigateRoute
  '/plan/select': typeof PlanSelectRouteWithChildren
  '/settings/pois': typeof SettingsPoisRoute
  '/stop/$stopId': typeof StopStopIdRoute
  '/trip/$tripId': typeof TripTripIdRouteWithChildren
  '/plan/': typeof PlanIndexRoute
  '/plan/select/$selectType': typeof PlanSelectSelectTypeRoute
  '/trip/$tripId/$date': typeof TripTripIdDateRoute
  '/plan/poi/': typeof PlanPoiIndexRoute
  '/plan/poi/$selectType/': typeof PlanPoiSelectTypeIndexRoute
  '/plan/$mode/$coordinates/$datetime/$type/$page/$itinIndex': typeof PlanModeCoordinatesDatetimeTypePageItinIndexRoute
  '/plan/$mode/$coordinates/$datetime/$type/$page/': typeof PlanModeCoordinatesDatetimeTypePageIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/filter'
    | '/search'
    | '/settings'
    | '/micromobility/$stopId'
    | '/plan/itinerary'
    | '/plan/navigate'
    | '/plan/select'
    | '/settings/pois'
    | '/stop/$stopId'
    | '/trip/$tripId'
    | '/plan/'
    | '/plan/select/$selectType'
    | '/trip/$tripId/$date'
    | '/plan/poi/'
    | '/plan/poi/$selectType/'
    | '/plan/$mode/$coordinates/$datetime/$type/$page/$itinIndex'
    | '/plan/$mode/$coordinates/$datetime/$type/$page/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/filter'
    | '/search'
    | '/settings'
    | '/micromobility/$stopId'
    | '/plan/itinerary'
    | '/plan/navigate'
    | '/plan/select'
    | '/settings/pois'
    | '/stop/$stopId'
    | '/trip/$tripId'
    | '/plan'
    | '/plan/select/$selectType'
    | '/trip/$tripId/$date'
    | '/plan/poi'
    | '/plan/poi/$selectType'
    | '/plan/$mode/$coordinates/$datetime/$type/$page/$itinIndex'
    | '/plan/$mode/$coordinates/$datetime/$type/$page'
  id:
    | '__root__'
    | '/'
    | '/filter'
    | '/search'
    | '/settings'
    | '/micromobility/$stopId'
    | '/plan/itinerary'
    | '/plan/navigate'
    | '/plan/select'
    | '/settings/pois'
    | '/stop/$stopId'
    | '/trip/$tripId'
    | '/plan/'
    | '/plan/select/$selectType'
    | '/trip/$tripId/$date'
    | '/plan/poi/'
    | '/plan/poi/$selectType/'
    | '/plan/$mode/$coordinates/$datetime/$type/$page/$itinIndex'
    | '/plan/$mode/$coordinates/$datetime/$type/$page/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  FilterRoute: typeof FilterRoute
  SearchRoute: typeof SearchRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  MicromobilityStopIdRoute: typeof MicromobilityStopIdRoute
  PlanItineraryRoute: typeof PlanItineraryRoute
  PlanNavigateRoute: typeof PlanNavigateRoute
  PlanSelectRoute: typeof PlanSelectRouteWithChildren
  StopStopIdRoute: typeof StopStopIdRoute
  TripTripIdRoute: typeof TripTripIdRouteWithChildren
  PlanIndexRoute: typeof PlanIndexRoute
  PlanPoiIndexRoute: typeof PlanPoiIndexRoute
  PlanPoiSelectTypeIndexRoute: typeof PlanPoiSelectTypeIndexRoute
  PlanModeCoordinatesDatetimeTypePageItinIndexRoute: typeof PlanModeCoordinatesDatetimeTypePageItinIndexRoute
  PlanModeCoordinatesDatetimeTypePageIndexRoute: typeof PlanModeCoordinatesDatetimeTypePageIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/filter': {
      id: '/filter'
      path: '/filter'
      fullPath: '/filter'
      preLoaderRoute: typeof FilterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plan/': {
      id: '/plan/'
      path: '/plan'
      fullPath: '/plan/'
      preLoaderRoute: typeof PlanIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trip/$tripId': {
      id: '/trip/$tripId'
      path: '/trip/$tripId'
      fullPath: '/trip/$tripId'
      preLoaderRoute: typeof TripTripIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stop/$stopId': {
      id: '/stop/$stopId'
      path: '/stop/$stopId'
      fullPath: '/stop/$stopId'
      preLoaderRoute: typeof StopStopIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/pois': {
      id: '/settings/pois'
      path: '/pois'
      fullPath: '/settings/pois'
      preLoaderRoute: typeof SettingsPoisRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/plan/select': {
      id: '/plan/select'
      path: '/plan/select'
      fullPath: '/plan/select'
      preLoaderRoute: typeof PlanSelectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plan/navigate': {
      id: '/plan/navigate'
      path: '/plan/navigate'
      fullPath: '/plan/navigate'
      preLoaderRoute: typeof PlanNavigateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plan/itinerary': {
      id: '/plan/itinerary'
      path: '/plan/itinerary'
      fullPath: '/plan/itinerary'
      preLoaderRoute: typeof PlanItineraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/micromobility/$stopId': {
      id: '/micromobility/$stopId'
      path: '/micromobility/$stopId'
      fullPath: '/micromobility/$stopId'
      preLoaderRoute: typeof MicromobilityStopIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plan/poi/': {
      id: '/plan/poi/'
      path: '/plan/poi'
      fullPath: '/plan/poi/'
      preLoaderRoute: typeof PlanPoiIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trip/$tripId/$date': {
      id: '/trip/$tripId/$date'
      path: '/$date'
      fullPath: '/trip/$tripId/$date'
      preLoaderRoute: typeof TripTripIdDateRouteImport
      parentRoute: typeof TripTripIdRoute
    }
    '/plan/select/$selectType': {
      id: '/plan/select/$selectType'
      path: '/$selectType'
      fullPath: '/plan/select/$selectType'
      preLoaderRoute: typeof PlanSelectSelectTypeRouteImport
      parentRoute: typeof PlanSelectRoute
    }
    '/plan/poi/$selectType/': {
      id: '/plan/poi/$selectType/'
      path: '/plan/poi/$selectType'
      fullPath: '/plan/poi/$selectType/'
      preLoaderRoute: typeof PlanPoiSelectTypeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plan/$mode/$coordinates/$datetime/$type/$page/': {
      id: '/plan/$mode/$coordinates/$datetime/$type/$page/'
      path: '/plan/$mode/$coordinates/$datetime/$type/$page'
      fullPath: '/plan/$mode/$coordinates/$datetime/$type/$page/'
      preLoaderRoute: typeof PlanModeCoordinatesDatetimeTypePageIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plan/$mode/$coordinates/$datetime/$type/$page/$itinIndex': {
      id: '/plan/$mode/$coordinates/$datetime/$type/$page/$itinIndex'
      path: '/plan/$mode/$coordinates/$datetime/$type/$page/$itinIndex'
      fullPath: '/plan/$mode/$coordinates/$datetime/$type/$page/$itinIndex'
      preLoaderRoute: typeof PlanModeCoordinatesDatetimeTypePageItinIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface SettingsRouteChildren {
  SettingsPoisRoute: typeof SettingsPoisRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsPoisRoute: SettingsPoisRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

interface PlanSelectRouteChildren {
  PlanSelectSelectTypeRoute: typeof PlanSelectSelectTypeRoute
}

const PlanSelectRouteChildren: PlanSelectRouteChildren = {
  PlanSelectSelectTypeRoute: PlanSelectSelectTypeRoute,
}

const PlanSelectRouteWithChildren = PlanSelectRoute._addFileChildren(
  PlanSelectRouteChildren,
)

interface TripTripIdRouteChildren {
  TripTripIdDateRoute: typeof TripTripIdDateRoute
}

const TripTripIdRouteChildren: TripTripIdRouteChildren = {
  TripTripIdDateRoute: TripTripIdDateRoute,
}

const TripTripIdRouteWithChildren = TripTripIdRoute._addFileChildren(
  TripTripIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  FilterRoute: FilterRoute,
  SearchRoute: SearchRoute,
  SettingsRoute: SettingsRouteWithChildren,
  MicromobilityStopIdRoute: MicromobilityStopIdRoute,
  PlanItineraryRoute: PlanItineraryRoute,
  PlanNavigateRoute: PlanNavigateRoute,
  PlanSelectRoute: PlanSelectRouteWithChildren,
  StopStopIdRoute: StopStopIdRoute,
  TripTripIdRoute: TripTripIdRouteWithChildren,
  PlanIndexRoute: PlanIndexRoute,
  PlanPoiIndexRoute: PlanPoiIndexRoute,
  PlanPoiSelectTypeIndexRoute: PlanPoiSelectTypeIndexRoute,
  PlanModeCoordinatesDatetimeTypePageItinIndexRoute:
    PlanModeCoordinatesDatetimeTypePageItinIndexRoute,
  PlanModeCoordinatesDatetimeTypePageIndexRoute:
    PlanModeCoordinatesDatetimeTypePageIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
